import { render } from "./EquipamentPage.vue?vue&type=template&id=40878882&scoped=true&ts=true"
import script from "./EquipamentPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EquipamentPage.vue?vue&type=script&lang=ts&setup=true"

import "./EquipamentPage.vue?vue&type=style&index=0&id=40878882&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40878882"],['__file',"src/pages/settings/pages/equipment/EquipamentPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40878882"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40878882', __exports__)) {
    api.reload('40878882', __exports__)
  }
  
  module.hot.accept("./EquipamentPage.vue?vue&type=template&id=40878882&scoped=true&ts=true", () => {
    api.rerender('40878882', render)
  })

}


export default __exports__